export default __webpack_public_path__ + "static/media/sec1-bg.9c892399.jpg";